// iconUtils.js
import React from 'react';
import * as LucideIcons from 'lucide-react';

// Normalize: split on separators and lower->upper boundaries
const normalize = (str) =>
    str
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .replace(/[_-\s]+/g, ' ')
        .trim();

const toPascalCase = (str) =>
    normalize(str)
        .split(' ')
        .filter(Boolean)
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join('');

export const getIcon = (iconName) => {
    if (!iconName) return LucideIcons.Circle;

    // 1) exact match first
    if (LucideIcons[iconName]) return LucideIcons[iconName];

    // 2) try PascalCase normalization
    const pascal = toPascalCase(iconName);
    if (LucideIcons[pascal]) return LucideIcons[pascal];

    // 3) (optional) try capitalizing first letter only — covers 'heart' -> 'Heart'
    const capFirst = iconName.charAt(0).toUpperCase() + iconName.slice(1);
    if (LucideIcons[capFirst]) return LucideIcons[capFirst];

    // Fallback
    return LucideIcons.Circle;
};

export const DynamicIcon = ({ name, size = 16, className, ...props }) => {
    const IconComponent = getIcon(name);
    return <IconComponent size={size} className={className} {...props} />;
};
